module.exports = __webpack_public_path__ + "media/images/guide-thumb-9-ed56ea2cd1fc2f524fe07d69bbd14493.png";